import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PublisherRepresentativeView } from "./PublisherRepresentativeView";
import { PublisherRepresentativeViewStore } from "../../store/PublisherRepresentativeViewStore";
import { useStore } from "../../../../hooks";

export const PublisherRepresentativeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/publisherRepresentative/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PublisherRepresentativeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PublisherRepresentativeView publisherRepresentativeViewStore={store} />
      </PageLayout>
    </div>
  );
});
